import { useEffect } from "react";

// SourceForge / Slashdot review badges (listing 4147772). Third-party script,
// so this must only ever render on public marketing pages -- never anywhere
// customer data is on screen. Rendered only by PublicFooter on Home.
const BADGE_SCRIPT_SRCS = [
  "https://b.sf-syn.com/badge_js?sf_id=4147772&variant_id=sf",
  "https://b.sf-syn.com/badge_js?sf_id=4147772&variant_id=sd",
];

export default function ReviewBadges() {
  // Script tags rendered through JSX never execute, so inject them after
  // mount and remove them on unmount; otherwise every route change that
  // remounts the footer would add another copy. The data attribute lets
  // scripts/prerender.js strip them from the static HTML it snapshots.
  useEffect(() => {
    const scripts = BADGE_SCRIPT_SRCS.map((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.dataset.reviewBadge = "";
      document.body.appendChild(script);
      return script;
    });
    return () => scripts.forEach((script) => script.remove());
  }, []);

  return (
    <>
      <div className="sf-root" data-id="4147772" data-badge="dark-default" data-variant-id="sf" style={{ width: "80px" }}>
        <a href="https://sourceforge.net/software/product/RunMark/" target="_blank" rel="noopener noreferrer">RunMark Reviews</a>
      </div>
      <div className="sf-root" data-id="4147772" data-badge="dark-default" data-variant-id="sd" style={{ width: "80px" }}>
        <a href="https://slashdot.org/software/p/RunMark/" target="_blank" rel="noopener noreferrer">RunMark Reviews</a>
      </div>
    </>
  );
}
